import { useState } from 'react';

interface CopyableProps {
  label: string;
  text: string;
  rows?: number;
}

export function Copyable({ label, text, rows = 10 }: CopyableProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
        <span style={{ fontWeight: 600, fontSize: '13px', color: '#444', fontFamily: 'monospace' }}>
          {label}
        </span>
        <button
          onClick={handleCopy}
          style={{
            padding: '4px 12px',
            fontSize: '12px',
            fontWeight: 600,
            background: copied ? '#22c55e' : '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'background 0.15s',
          }}
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
      <textarea
        readOnly
        value={text}
        rows={rows}
        style={{
          width: '100%',
          fontFamily: 'monospace',
          fontSize: '11px',
          padding: '8px',
          border: '1px solid #d0d0d0',
          borderRadius: '4px',
          background: '#fafafa',
          resize: 'vertical',
          boxSizing: 'border-box',
          color: '#222',
          lineHeight: '1.4',
        }}
      />
    </div>
  );
}
